import React, { useMemo } from "react";
import PropTypes from "prop-types";

import Modal from "Components/Common/Modal";
import PermanentConnection from "pages/Consumer/OtherApplications/PermanentConnection";
import TemporaryConnection from "pages/Consumer/OtherApplications/TemporaryConnection";
import OtherApplicationNameTransfer from "pages/Consumer/OtherApplications/NameChangeTransfer";
import OtherUtilityDemandReduction from "pages/Consumer/OtherApplications/DemandReduction";
import OtherUtilityDemandExtension from "pages/Consumer/OtherApplications/DemandExtension";
import OtherApplicationRemovalOfConnection from "pages/Consumer/OtherApplications/RemovalOfConnection";

import { applicationTypes } from "common/constant";

const getKeyByValue = (object, value) => {
  return Object.keys(object).find((key) => object[key] === value);
};

const OtherApplicationsEditModal = ({
  editApplicationQuery,
  applicationTypeId,
  handleClose,
}) => {
  const editApplicationTypes = useMemo(
    () => ({
      1: (
        <PermanentConnection
          editApplicationQuery={editApplicationQuery}
          handleClose={handleClose}
        />
      ),

      2: (
        <TemporaryConnection
          editApplicationQuery={editApplicationQuery}
          handleClose={handleClose}
        />
      ),

      3: (
        <OtherApplicationNameTransfer
          editApplicationQuery={editApplicationQuery}
          handleClose={handleClose}
        />
      ),

      4: (
        <OtherUtilityDemandReduction
          editApplicationQuery={editApplicationQuery}
          handleClose={handleClose}
        />
      ),

      5: (
        <OtherUtilityDemandExtension
          editApplicationQuery={editApplicationQuery}
          handleClose={handleClose}
        />
      ),
      12: (
        <OtherApplicationRemovalOfConnection
          editApplicationQuery={editApplicationQuery}
          handleClose={handleClose}
        />
      ),
    }),
    [editApplicationQuery]
  );

  return (
    <>
      {applicationTypeId && editApplicationQuery && (
        <Modal
          isOpen={!!editApplicationQuery}
          handleClose={handleClose}
          maxWidth="lg"
          title={`Edit ${getKeyByValue(applicationTypes, applicationTypeId)}`}
        >
          {editApplicationTypes[applicationTypeId]}
        </Modal>
      )}
    </>
  );
};

OtherApplicationsEditModal.propTypes = {
  editApplicationQuery: PropTypes.object,
  applicationTypeId: PropTypes.number,
  handleClose: PropTypes.func,
};
export default OtherApplicationsEditModal;
